import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component export class FaqSidebar extends ThemeComponent {

    @Ref() sidebarTitle!: HTMLElement[];
    init() {
        for (const title of this.sidebarTitle) {
            title.addEventListener('click', (event) => {
                const clickedTitle = event.target as HTMLElement;
                if (clickedTitle) {
                // Remove 'active' class from all titles
                    for (const otherTitle of this.sidebarTitle) {
                        otherTitle.classList.remove('active');
                    }

                    // Add 'active' class to the clicked title
                    clickedTitle.classList.add('active');

                }
            });
        }
    }
}
